import { render, staticRenderFns } from "./ontick-number-input.component.vue?vue&type=template&id=31723f65&scoped=true"
import script from "./ontick-number-input.component.vue?vue&type=script&lang=js"
export * from "./ontick-number-input.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-number-input.component.vue?vue&type=style&index=0&id=31723f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31723f65",
  null
  
)

export default component.exports